// @ts-nocheck
import {
  ARENA_THEMES,
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  playerBotTag,
  capitalizeDisplayName,
  TITLE_SUFFIX,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../../util";
import {
  drawSpellIcon,
  isSpellIconReady,
} from "../../spell-icons";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../../lobby";

import { Game } from "../game-base";
import { uiFont, voidNameGradient } from "../../ui-tokens";

function drawNameplateLabel(c, sx, sy, name, title, titlePos, nameColor, botTag, ally, admin) {
  const display = capitalizeDisplayName(name);
  const parts = [];
  if (ally) parts.push({ text: "▲ ", color: nameColor });
  if (title && titlePos === 1) parts.push({ text: `${title} `, color: "#ffd479" });
  parts.push({ text: display, color: nameColor, grad: !!admin });
  if (title && titlePos === TITLE_SUFFIX) parts.push({ text: ` ${title}`, color: "#ffd479" });
  if (botTag) parts.push({ text: botTag, color: nameColor });

  c.textAlign = "left";
  c.font = uiFont(600, "xs");
  c.lineWidth = 3;
  c.strokeStyle = "rgba(0,0,0,0.7)";
  let totalW = 0;
  for (const p of parts) totalW += c.measureText(p.text).width;
  let x = sx - totalW / 2;
  for (const p of parts) {
    const w = c.measureText(p.text).width;
    c.fillStyle = p.grad ? voidNameGradient(c, x, w) : p.color;
    c.strokeText(p.text, x, sy);
    c.fillText(p.text, x, sy);
    x += w;
  }
}

Game.prototype.drawCursorHint = function () {
    const hint = this.cursorHint;
    if (!hint) return;
    const now = this.now;
    if (now > hint.until) return;
    const s = SPELLS[hint.id], p = this.human();
    let label;
    if (hint.kind === "silenced") label = "Silenced";
    else if (hint.kind === "frozen") label = "Frozen";
    else {
      const cd = (this.sandboxNoCD || !p || !p.cd) ? 0 : (p.cd[hint.id] || 0);
      label = cd > 0 ? `${cd.toFixed(1)}s` : "Ready";
    }
    const c = this.ctx;
    c.save();
    c.font = "700 14px 'Trebuchet MS', sans-serif"; c.textBaseline = "middle"; c.textAlign = "left";
    const padX = 8, iconSz = 18, iconGap = 5;
    const showIcon = s && isSpellIconReady(hint.id);
    const textW = c.measureText(label).width;
    const w = padX + (showIcon ? iconSz + iconGap : 0) + textW + padX;
    const h = 24;
    const x = Math.min(this.mouse.x + 18, this.W - w - 4), y = this.mouse.y + 20;
    c.globalAlpha = clamp((hint.until - now) / 350, 0, 1);
    c.fillStyle = "rgba(18,14,36,0.9)";
    c.strokeStyle = "rgba(255,110,110,0.7)"; c.lineWidth = 1.5;
    c.beginPath(); c.roundRect(x, y - h / 2, w, h, 6); c.fill(); c.stroke();
    let tx = x + padX;
    if (showIcon) {
      drawSpellIcon(c, tx + iconSz / 2, y + 1, iconSz, hint.id);
      tx += iconSz + iconGap;
    }
    c.fillStyle = "#ff9a9a";
    c.fillText(label, tx, y + 1);
    c.restore();
  }

Game.prototype.drawNameplates = function () {
    const c = this.ctx;
    const me = this.human();
    c.save();
    c.textBaseline = "bottom";
    const drawPlate = (wx, wy, radius, pl, invisT) => {
      if (!pl?.name) return;
      const sx = this.cx + (wx - this.camX) * this.scale;
      const sy = this.cy + (wy - this.camY) * this.scaleY - radius * this.scale * 4.2 - 8;
      const ally = me && pl !== me && pl.team != null && pl.team === me.team;
      c.globalAlpha = invisT > 0 ? 0.5 : 1;
      const nameColor = ally ? "#74f7a0" : (pl.robe || "#fff");
      drawNameplateLabel(c, sx, sy, pl.name, pl.title, pl.titlePos, nameColor, playerBotTag(pl), ally, pl.admin);
    };
    for (const p of this.players) {
      if (!p.alive || p.falling || !p.name) continue;
      if (p.invisT > 0 && p !== me) continue;
      drawPlate(p.x, p.y, p.radius, p, p.invisT);
    }
    for (const d of this.decoys) {
      const owner = this.playerById[d.ownerId];
      if (!owner || !owner.alive || owner.falling || !owner.name) continue;
      if (owner.invisT > 0 && owner !== me) continue;
      drawPlate(d.x, d.y, d.radius, owner, owner.invisT);
    }
    c.restore();
  }

Game.prototype.drawHPBarWorld = function (wx, wy, radius, hp, outside, maxHp, bossId, bossAdd) {
    const cap = maxHp || CFG.maxHP;
    if (hp >= cap && !outside) return;
    const c = this.ctx;
    const isBossBar = maxHp > CFG.maxHP;
    const bw = isBossBar ? 80 : 40, bh = isBossBar ? 9 : 5;
    let by;
    if (isBossBar) {
      let crown;
      if (bossId === "aurelion") crown = radius * 3.4;
      else if (bossId === "ixtholoth") crown = radius * 3.6;
      else if (bossAdd) crown = radius * 3.75;
      else if (bossId === "kael") crown = radius * 5.25;
      else if (bossId) crown = radius * 5.75;
      else crown = radius * 3.75;
      by = wy - crown - 12 - bh;
    } else {
      by = wy - radius * 3.2 - bh;
    }
    const bx = wx - bw / 2;
    const frac = clamp(hp / cap, 0, 1);
    c.save();
    c.fillStyle = "rgba(0,0,0,0.55)";
    c.fillRect(bx - 1, by - 1, bw + 2, bh + 2);
    const hue = 120 * frac;
    c.fillStyle = outside ? `hsl(${hue}, 90%, ${50 + 10 * Math.sin(this.now / 80)}%)`
                          : `hsl(${hue}, 80%, 50%)`;
    c.fillRect(bx, by, bw * frac, bh);
    if (isBossBar) {
      const pct = Math.round(frac * 100);
      c.font = "700 11px 'Trebuchet MS', sans-serif";
      c.textAlign = "center";
      c.textBaseline = "middle";
      c.fillStyle = frac > 0.35 ? "#fff" : "#ffd479";
      c.fillText(`${pct}%`, bx + bw / 2, by + bh / 2 + 0.5);
    }
    c.restore();
  }

Game.prototype.drawDmgPopups = function () {
    if (!this.dmgPopups.length) return;
    const c = this.ctx;
    c.save();
    c.textAlign = "center"; c.textBaseline = "middle";
    for (const d of this.dmgPopups) {
      const sx = this.cx + (d.x - this.camX) * this.scale;
      const sy = this.cy + (d.y - this.camY) * this.scaleY;
      const k = d.t / d.life;
      c.globalAlpha = clamp(1 - k * k, 0, 1);
      const baseSize = d.sizePx || 22;
      const size = baseSize * (1 - 0.25 * k);
      c.font = `700 ${size}px 'Trebuchet MS', sans-serif`;
      c.lineWidth = d.strokePx || 3.5;
      c.strokeStyle = d.dot ? "rgba(0,0,0,0.55)" : "rgba(0,0,0,0.75)";
      c.fillStyle = d.color || (d.heal ? "#74f7a0" : "#ffe27a");
      c.strokeText(d.val, sx, sy);
      c.fillText(d.val, sx, sy);
    }
    c.restore();
  }

const SLAB_LIGHT_ANG = Math.PI * 1.25;

// Chunky 3D boulders: cliff-toned walls flaring from the ground + flat chiselled cap.
Game.prototype.drawPillars = function () {
    for (const pl of this.pillars) if (pl.active) this.drawPillar(pl);
  }

Game.prototype.drawPillar = function (pl) {
    const c = this.ctx;
    const viz = CFG.platformViz;
    const lcx = Math.cos(SLAB_LIGHT_ANG), lcy = Math.sin(SLAB_LIGHT_ANG);
    const inv = this.scale / this.scaleY;
    const r = pl.r;
    const H = r * 0.58 * inv;
    const seed = pl.seed || 0;
    const jit = (i) => { const h = Math.sin(seed * 11.7 + i * 51.37) * 43758.5453; return h - Math.floor(h); };
    const N = 12;
    const fp = [];
    const baseFp = [];
    for (let i = 0; i < N; i++) {
      const a = (i / N) * TAU + (jit(i + 40) - 0.5) * 0.45;
      const capRr = r * (0.58 + 0.46 * jit(i));
      const baseRr = r * (0.84 + 0.2 * jit(i + 15));
      fp.push({ x: Math.cos(a) * capRr, y: Math.sin(a) * capRr });
      baseFp.push({ x: Math.cos(a) * baseRr, y: Math.sin(a) * baseRr });
    }
    c.save();
    c.translate(pl.x, pl.y);

    // soft ground contact — wider than the cap so the mass reads rooted in the slab
    c.fillStyle = "rgba(0,0,0,0.34)";
    c.beginPath(); c.ellipse(r * 0.28, r * 0.30, r * 1.05, r * 0.6, 0, 0, TAU); c.fill();
    c.fillStyle = "rgba(20,16,32,0.22)";
    c.beginPath();
    for (let i = 0; i < N; i++) {
      const p = baseFp[i];
      if (i) c.lineTo(p.x, p.y); else c.moveTo(p.x, p.y);
    }
    c.closePath();
    c.fill();

    // front + side walls — flare outward toward the ground (emerging from the slab)
    for (let i = 0; i < N; i++) {
      const p = fp[i], q = fp[(i + 1) % N];
      const bp = baseFp[i], bq = baseFp[(i + 1) % N];
      let nx = q.y - p.y, ny = -(q.x - p.x);
      const nl = Math.hypot(nx, ny) || 1;
      nx /= nl; ny /= nl;
      if (ny < -0.05) continue;
      const topY = Math.min(p.y - H, q.y - H);
      const botY = Math.max(bp.y, bq.y);
      c.beginPath();
      c.moveTo(p.x, p.y - H); c.lineTo(q.x, q.y - H);
      c.lineTo(bq.x, bq.y); c.lineTo(bp.x, bp.y);
      c.closePath();
      const g = c.createLinearGradient(0, topY, 0, botY);
      g.addColorStop(0, viz.cliffTop);
      g.addColorStop(0.4, viz.cliffMid);
      g.addColorStop(1, viz.cliffBot);
      c.fillStyle = g; c.fill();
      const o = nx * lcx + ny * lcy;
      c.fillStyle = o >= 0 ? `rgba(206,214,255,${o * 0.26})` : `rgba(0,0,0,${-o * 0.48})`;
      c.fill();
      const edgeX = (t) => p.x + (q.x - p.x) * t;
      const edgeY = (t, f) => {
        const yTop = (p.y - H) + (q.y - H - (p.y - H)) * t;
        const yBot = bp.y + (bq.y - bp.y) * t;
        return yTop + (yBot - yTop) * f;
      };
      c.strokeStyle = `rgba(0,0,0,${0.12 + (1 - (o + 1) * 0.5) * 0.14})`;
      c.lineWidth = 0.75;
      c.beginPath();
      c.moveTo(edgeX(0.06), edgeY(0.06, 0.38));
      c.lineTo(edgeX(0.94), edgeY(0.94, 0.38));
      c.moveTo(edgeX(0.06), edgeY(0.06, 0.72));
      c.lineTo(edgeX(0.94), edgeY(0.94, 0.72));
      c.stroke();
    }

    // flat chiselled cap — walkable stone top; low-poly facet shading, no spiky crown
    const cap = () => {
      c.beginPath();
      for (let i = 0; i < N; i++) {
        const p = fp[i];
        if (i) c.lineTo(p.x, p.y - H); else c.moveTo(p.x, p.y - H);
      }
      c.closePath();
    };
    cap();
    const tg = c.createRadialGradient(-r * 0.34, -r * 0.42 - H, r * 0.08, 0, -H, r * 1.2);
    tg.addColorStop(0, "#9a94b0");
    tg.addColorStop(0.5, "#6d6784");
    tg.addColorStop(1, "#45405a");
    c.fillStyle = tg; c.fill();

    for (let i = 0; i < N; i++) {
      const p = fp[i], q = fp[(i + 1) % N];
      const dx = (p.x + q.x) * 0.5, dy = (p.y + q.y) * 0.5;
      const dl = Math.hypot(dx, dy) || 1;
      const o = (dx / dl) * lcx + (dy / dl) * lcy;
      c.beginPath();
      c.moveTo(0, -H);
      c.lineTo(p.x, p.y - H);
      c.lineTo(q.x, q.y - H);
      c.closePath();
      c.fillStyle = o >= 0 ? `rgba(214,220,255,${o * 0.16})` : `rgba(0,0,0,${-o * 0.2})`;
      c.fill();
    }

    cap();
    c.lineJoin = "round";
    c.lineWidth = 2; c.strokeStyle = "rgba(8,6,16,0.55)"; c.stroke();
    c.lineWidth = 1.6; c.strokeStyle = "rgba(206,214,255,0.38)";
    c.beginPath();
    let lipOn = false;
    for (let i = 0; i <= N; i++) {
      const p = fp[i % N];
      const a = (i / N) * TAU;
      const toward = Math.cos(a) * lcx + Math.sin(a) * lcy;
      if (toward > 0.1) {
        if (lipOn) c.lineTo(p.x, p.y - H);
        else { c.moveTo(p.x, p.y - H); lipOn = true; }
      } else lipOn = false;
    }
    c.stroke();

    c.restore();
  }

// Sandbox-only debug overlay: the real collision footprints (arena kill ring,
// stones, wizards) drawn flat in world space, so they foreshorten with the
// ground — making the gap between a stone's footprint and its raised cap visible.
// Only ever runs when this.showHitboxes is on (toggled with H in sandbox).
Game.prototype.drawHitboxes = function () {
    const c = this.ctx;
    c.save();
    c.lineWidth = 1.4 / this.scale;            // ~constant on-screen thickness
    c.strokeStyle = "rgba(255,80,80,0.9)";     // arena kill boundary
    c.beginPath(); c.arc(0, 0, this.platformRadius, 0, TAU); c.stroke();
    c.strokeStyle = "rgba(120,200,255,0.95)";  // stones
    for (const pl of this.pillars) {
      if (!pl.active) continue;
      c.beginPath(); c.arc(pl.x, pl.y, pl.r, 0, TAU); c.stroke();
    }
    c.strokeStyle = "rgba(120,255,140,0.95)";  // wizards
    for (const p of this.players) {
      if (!p.alive) continue;
      c.beginPath(); c.arc(p.x, p.y, p.radius, 0, TAU); c.stroke();
    }
    c.restore();
  }

Game.prototype.arenaTheme = function () {
  const id = this.activeBossId?.() || "";
  return ARENA_THEMES[id] || ARENA_THEMES.default;
};

Game.prototype.applyFloorWash = function (c, r, wash) {
  if (!wash) return;
  const t = this.nowS;
  if (wash.kind === "split") {
    const gNW = c.createLinearGradient(-r, -r, 0, 0);
    gNW.addColorStop(0, wash.nw);
    gNW.addColorStop(1, "rgba(0,0,0,0)");
    c.fillStyle = gNW;
    c.fillRect(-r, -r, r, r);
    const gNE = c.createLinearGradient(r, -r, 0, 0);
    gNE.addColorStop(0, wash.ne);
    gNE.addColorStop(1, "rgba(0,0,0,0)");
    c.fillStyle = gNE;
    c.fillRect(0, -r, r, r);
    return;
  }
  if (wash.kind === "rift") {
    const riftR = r * (wash.radius ?? 0.34);
    const swirl = c.createRadialGradient(0, 0, 0, 0, 0, riftR);
    swirl.addColorStop(0, wash.inner);
    swirl.addColorStop(0.45, wash.mid);
    swirl.addColorStop(0.85, wash.outer);
    swirl.addColorStop(1, wash.edge);
    c.fillStyle = swirl;
    c.beginPath(); c.arc(0, 0, riftR, 0, TAU); c.fill();
    c.strokeStyle = `${wash.strokeColor},${0.32 + 0.14 * Math.sin(t * 1.1)})`;
    c.lineWidth = 2.5;
    c.setLineDash([12, 9]);
    c.beginPath();
    c.arc(0, 0, riftR * 0.72 + Math.sin(t * 0.75) * 3, t * 0.35, t * 0.35 + TAU);
    c.stroke();
    c.setLineDash([]);
    return;
  }
  if (wash.kind === "spokes") {
    const innerR = r * (wash.innerR ?? 0.15);
    const frost = c.createRadialGradient(0, 0, innerR, 0, 0, r);
    frost.addColorStop(0, wash.inner);
    frost.addColorStop(0.55, wash.mid);
    frost.addColorStop(1, wash.outer);
    c.fillStyle = frost;
    c.fillRect(-r, -r, r * 2, r * 2);
    const spokeCount = wash.spokeCount ?? 5;
    c.strokeStyle = `${wash.spokeColor},${0.12 + 0.06 * Math.sin(t * 0.8)})`;
    c.lineWidth = 1.5;
    for (let i = 0; i < spokeCount; i++) {
      const a = (i / spokeCount) * TAU + t * 0.05;
      c.beginPath();
      c.moveTo(Math.cos(a) * r * 0.2, Math.sin(a) * r * 0.2);
      c.lineTo(Math.cos(a) * r * 0.88, Math.sin(a) * r * 0.88);
      c.stroke();
    }
    return;
  }
  if (wash.kind === "radial") {
    const innerR = r * (wash.innerR ?? 0.1);
    const g = c.createRadialGradient(0, 0, innerR, 0, 0, r);
    g.addColorStop(0, wash.inner);
    g.addColorStop(0.55, wash.mid);
    g.addColorStop(1, wash.outer);
    c.fillStyle = g;
    c.fillRect(-r, -r, r * 2, r * 2);
  }
};

Game.prototype.drawStars = function () {
    const c = this.ctx;
    const t = this.nowS;
    const W = this.W, H = this.H;
    // Parallax: drift the field opposite the camera by a small fraction so the
    // platform reads as floating over a deep void. Wrap so the field still tiles.
    const px = this.camX * CFG.starParallax, py = this.camY * CFG.starParallax;
    // Batch by quantized alpha so ~10 fill calls replace hundreds of per-star arcs.
    if (!this._starBuckets) {
      this._starBuckets = [];
      for (let i = 0; i < 10; i++) this._starBuckets.push([]);
    }
    const buckets = this._starBuckets;
    for (let i = 0; i < 10; i++) buckets[i].length = 0;
    for (const s of this.stars) {
      const x = ((s.x - px) % W + W) % W;
      const y = ((s.y - py) % H + H) % H;
      const a = s.a * (0.6 + 0.4 * Math.sin(t * s.tw + s.p));
      buckets[Math.min(9, (a * 10) | 0)].push(x, y, s.r);
    }
    c.fillStyle = this.arenaTheme().starTint || "#cdd6ff";
    for (let b = 0; b < 10; b++) {
      const pts = buckets[b];
      if (!pts.length) continue;
      c.globalAlpha = (b + 0.5) / 10;
      c.beginPath();
      for (let i = 0; i < pts.length; i += 3) {
        const x = pts[i], y = pts[i + 1], r = pts[i + 2];
        c.moveTo(x + r, y);
        c.arc(x, y, r, 0, TAU);
      }
      c.fill();
    }
    c.globalAlpha = 1;
  }

Game.prototype.bakeIdlePlatformTex = function () {
    const R = Math.max(1, Math.round(this.maxRadius));
    const viz = CFG.platformViz;
    const size = R * 2;
    const cv = document.createElement("canvas");
    cv.width = cv.height = size;
    const c = cv.getContext("2d");
    c.translate(R, R);
    c.save();
    c.beginPath(); c.arc(0, 0, R, 0, TAU); c.clip();
    const g = c.createRadialGradient(-R * 0.18, -R * 0.22, R * 0.1, 0, 0, R);
    g.addColorStop(0, "#3a3550"); g.addColorStop(1, "#1a1730");
    c.fillStyle = g;
    c.fillRect(-R, -R, size, size);
    const ao = c.createRadialGradient(0, 0, R * 0.74, 0, 0, R);
    ao.addColorStop(0, "rgba(0,0,0,0)"); ao.addColorStop(1, viz.edgeAO);
    c.fillStyle = ao; c.fillRect(-R, -R, size, size);
    c.restore();
    this._idlePlatformTex = cv;
    this._idlePlatformTexR = R;
  }

Game.prototype.drawIdlePlatform = function () {
    const c = this.ctx, r = this.maxRadius;
    const depth = r * CFG.platformDepth, viz = CFG.platformViz;
    if (!this._idlePlatformTex || this._idlePlatformTexR !== Math.round(r)) this.bakeIdlePlatformTex();
    c.save();
    c.translate(this.cx, this.cy);
    c.scale(this.scale, this.scaleY);
    this.drawSlabSide(r, depth, viz);
    c.save();
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.clip();
    c.drawImage(this._idlePlatformTex, -r, -r, r * 2, r * 2);
    c.restore();
    this.drawSlabRim(r, viz);
    c.restore();
  }

// Pre-bake the in-match platform texture while the player sits in the menu.
// bakePlatformTex is the heaviest single bake (a ~1900x1900 canvas with thousands
// of grain specks — up to ~0.5s on slow machines); left lazy, it runs on the
// first drawPlatform of the first match after page load, freezing right at
// "FIGHT!" (confirmed in the frame-health metrics). The menu never draws this
// texture, so warming it at idle moves the cost where nobody can feel it. A
// server-sent maxRadius other than CFG.worldRadius still re-bakes lazily.
Game.prototype.warmPlatformTextures = function () {
    if (this._platformTex && this._platformTexR === CFG.worldRadius) return;
    const saved = this.maxRadius;
    this.maxRadius = CFG.worldRadius;
    this.bakePlatformTex();
    this.maxRadius = saved;
  }

// Bake the stone top-face once per arena size (offscreen). The texture is anchored
// in world units at the full maxRadius; drawPlatform clips it to the current
// (shrinking) radius, so the rock stays put while the platform contracts.
Game.prototype.bakePlatformTex = function () {
    const R = Math.max(1, Math.round(this.maxRadius));
    const size = R * 2;
    const cv = document.createElement("canvas");
    cv.width = cv.height = size;
    const c = cv.getContext("2d");
    c.translate(R, R);
    c.save();
    c.beginPath(); c.arc(0, 0, R, 0, TAU); c.clip();
    // base stone gradient (lit toward upper-left, darker at the rim)
    const base = c.createRadialGradient(-R * 0.18, -R * 0.22, R * 0.1, 0, 0, R);
    base.addColorStop(0, "#5a5572");
    base.addColorStop(0.55, "#3c3856");
    base.addColorStop(1, "#211d38");
    c.fillStyle = base;
    c.fillRect(-R, -R, size, size);
    // fine stone grain: lots of tiny low-alpha specks (NOT big soft "bokeh" blobs)
    const grains = Math.floor(R * 6);
    for (let i = 0; i < grains; i++) {
      const a = Math.random() * TAU, rr = Math.sqrt(Math.random()) * R;
      const x = Math.cos(a) * rr, y = Math.sin(a) * rr;
      const br = rand(R * 0.003, R * 0.013), alpha = rand(0.02, 0.07);
      c.fillStyle = Math.random() < 0.5
        ? `rgba(176,168,202,${alpha})` : `rgba(12,9,22,${alpha})`;
      c.beginPath(); c.arc(x, y, br, 0, TAU); c.fill();
    }
    // a handful of very faint broad patches for large-scale tonal variation (kept subtle
    // enough to read as weathering, never as boulders)
    for (let i = 0; i < 7; i++) {
      const a = Math.random() * TAU, rr = Math.sqrt(Math.random()) * R * 0.92;
      const x = Math.cos(a) * rr, y = Math.sin(a) * rr;
      const br = rand(R * 0.12, R * 0.24);
      const g = c.createRadialGradient(x, y, 0, x, y, br);
      g.addColorStop(0, "rgba(10,8,18,0.05)");
      g.addColorStop(1, "rgba(10,8,18,0)");
      c.fillStyle = g;
      c.beginPath(); c.arc(x, y, br, 0, TAU); c.fill();
    }
    // a few branching cracks
    c.strokeStyle = "rgba(8,6,16,0.35)"; c.lineCap = "round";
    for (let i = 0; i < 5; i++) {
      const a0 = rand(0, TAU), rad0 = R * rand(0.1, 0.5);
      let x = Math.cos(a0) * rad0, y = Math.sin(a0) * rad0;
      let dir = rand(0, TAU);
      c.lineWidth = rand(1.5, 3.5);
      c.beginPath(); c.moveTo(x, y);
      const segs = 6 + Math.floor(Math.random() * 5);
      for (let s = 0; s < segs; s++) {
        dir += rand(-0.7, 0.7);
        const step = rand(R * 0.05, R * 0.14);
        x += Math.cos(dir) * step; y += Math.sin(dir) * step;
        c.lineTo(x, y);
      }
      c.stroke();
    }
    // faint concentric rings + runic center (kept from the old flat look)
    c.strokeStyle = "rgba(255,255,255,0.035)"; c.lineWidth = 1;
    for (let i = 1; i <= 3; i++) { c.beginPath(); c.arc(0, 0, R * (i / 4), 0, TAU); c.stroke(); }
    c.strokeStyle = "rgba(150,130,255,0.10)"; c.lineWidth = 2;
    c.beginPath(); c.arc(0, 0, Math.min(60, R * 0.35), 0, TAU); c.stroke();
    // upper-left sheen
    const sheen = c.createRadialGradient(-R * 0.4, -R * 0.45, R * 0.05, -R * 0.4, -R * 0.45, R * 1.1);
    sheen.addColorStop(0, "rgba(255,250,255,0.10)");
    sheen.addColorStop(0.4, "rgba(255,250,255,0)");
    c.fillStyle = sheen;
    c.fillRect(-R, -R, size, size);
    c.restore();
    this._platformTex = cv;
    this._platformTexR = this.maxRadius;
  }

function slabJit(i) {
  const h = Math.sin(i * 127.1 + 311.7) * 43758.5453;
  return h - Math.floor(h);
}

// Rim + tapered underside point for one segment index.
function slabUndersidePoint(r, depth, angle, i) {
  const jit = slabJit;
  const ct = Math.cos(angle), st = Math.sin(angle);
  const front = Math.max(0, st);                       // 1 at bottom centre, 0 at sides
  const taper = 0.22 + 0.78 * front;
  const inward = (0.14 + 0.26 * front) * (0.65 + 0.7 * jit(i + 50));
  const spikeRoll = jit(i + 17);
  let dropMult = 0.5 + 0.7 * taper;
  if (spikeRoll > 0.68) dropMult += 0.28 + spikeRoll * 0.62;   // spear-like columns
  else if (spikeRoll < 0.2) dropMult *= 0.42 + spikeRoll * 0.9; // stubby breaks
  const drop = depth * dropMult * (0.8 + 0.4 * jit(i));
  const br = r * (1 - inward);
  return {
    x: r * ct, y: r * st,
    bx: br * ct, by: r * st + drop,
    drop, front, spike: spikeRoll > 0.74,
    lit: 0.5 + 0.5 * Math.cos(angle - SLAB_LIGHT_ANG),
  };
}

// The chunky 3D underside: a tapered, jagged rock mass hanging off the lower rim.
// Bottom vertices pull inward toward the centre and vary wildly in depth so the
// silhouette reads as broken-off stone with pointy downward spires, not a smooth lip.
Game.prototype.paintSlabSide = function (c, r, depth, viz) {
    const jit = slabJit;
    const segs = Math.max(40, Math.min(110, Math.round(r / 12)));
    const a0 = -0.38, a1 = Math.PI + 0.38;
    const pts = [];
    for (let i = 0; i <= segs; i++) {
      const t = a0 + (a1 - a0) * (i / segs);
      pts.push(slabUndersidePoint(r, depth, t, i));
    }
    // 1) facet quads — rock columns, bottom edge is the jagged silhouette
    for (let i = 0; i < segs; i++) {
      const p = pts[i], q = pts[i + 1];
      const lit = (p.lit + q.lit) * 0.5;
      const topY = Math.min(p.y, q.y), botY = Math.max(p.by, q.by);
      c.beginPath();
      c.moveTo(p.x, p.y); c.lineTo(q.x, q.y); c.lineTo(q.bx, q.by); c.lineTo(p.bx, p.by);
      c.closePath();
      const g = c.createLinearGradient(0, topY, 0, botY);
      g.addColorStop(0, viz.cliffTop);
      g.addColorStop(0.38, viz.cliffMid);
      g.addColorStop(1, viz.cliffBot);
      c.fillStyle = g; c.fill();
      const o = lit - 0.5;
      c.fillStyle = o >= 0 ? `rgba(206,214,255,${o * 0.34})` : `rgba(0,0,0,${-o * 0.52})`;
      c.fill();
      // horizontal strata bands (layered-rock read)
      const bandY0 = topY + (botY - topY) * 0.38;
      const bandY1 = topY + (botY - topY) * 0.72;
      c.strokeStyle = `rgba(0,0,0,${0.14 + (1 - lit) * 0.12})`;
      c.lineWidth = 0.8;
      c.beginPath();
      c.moveTo(p.x + (p.bx - p.x) * 0.38, bandY0);
      c.lineTo(q.x + (q.bx - q.x) * 0.38, bandY0);
      c.moveTo(p.x + (p.bx - p.x) * 0.72, bandY1);
      c.lineTo(q.x + (q.bx - q.x) * 0.72, bandY1);
      c.stroke();
    }
    // 2) downward spires at the jaggiest bottom vertices
    for (let i = 1; i < segs; i++) {
      const p = pts[i];
      if (!p.spike) continue;
      const tipLen = depth * (0.16 + jit(i + 300) * 0.48);
      const hw = depth * (0.035 + jit(i + 301) * 0.055);
      const tx = p.bx, ty = p.by + tipLen;
      const tangent = Math.atan2(p.by - p.y, p.bx - p.x) + Math.PI * 0.5;
      const nx = Math.cos(tangent) * hw, ny = Math.sin(tangent) * hw;
      c.beginPath();
      c.moveTo(p.bx + nx, p.by + ny);
      c.lineTo(p.bx - nx, p.by - ny);
      c.lineTo(tx, ty);
      c.closePath();
      const g = c.createLinearGradient(p.bx, p.by, tx, ty);
      g.addColorStop(0, viz.cliffMid);
      g.addColorStop(1, viz.cliffBot);
      c.fillStyle = g; c.fill();
      c.strokeStyle = "rgba(0,0,0,0.35)";
      c.lineWidth = 0.7;
      c.stroke();
    }
    // 3) central front crevice (deep fold down the middle mass)
    const mid = (segs * 0.5) | 0;
    const crevice = [pts[mid - 1], pts[mid], pts[mid + 1]];
    c.lineWidth = 1.4; c.strokeStyle = "rgba(0,0,0,0.42)";
    c.beginPath();
    c.moveTo(crevice[0].x, crevice[0].y);
    for (const p of crevice) c.lineTo(p.bx, p.by);
    c.stroke();
    c.lineWidth = 0.7; c.strokeStyle = "rgba(80,72,110,0.22)";
    c.stroke();
    // 4) vertical crevice seams between facets
    c.lineWidth = 1; c.strokeStyle = viz.seam;
    for (let i = 2; i < segs - 1; i += 2) {
      const p = pts[i];
      c.beginPath(); c.moveTo(p.x, p.y); c.lineTo(p.bx, p.by); c.stroke();
    }
    // 5) optional extra stalactites (config spikeCount)
    const spikes = viz.spikeCount | 0;
    if (spikes > 0) {
      for (let s = 0; s < spikes; s++) {
        const t = 0.18 * Math.PI + (0.64 * Math.PI) * ((s + 0.5) / spikes) + (jit(s * 7 + 3) - 0.5) * 0.18;
        const p = slabUndersidePoint(r, depth, t, s * 9 + 400);
        const len = depth * viz.spikeLen * (0.6 + 0.8 * jit(s * 5 + 1));
        const hw = depth * (0.08 + 0.05 * jit(s * 13));
        const tangent = Math.atan2(p.by - p.y, p.bx - p.x) + Math.PI * 0.5;
        const nx = Math.cos(tangent) * hw, ny = Math.sin(tangent) * hw;
        c.beginPath();
        c.moveTo(p.bx + nx, p.by + ny);
        c.lineTo(p.bx - nx, p.by - ny);
        c.lineTo(p.bx, p.by + len);
        c.closePath();
        const g = c.createLinearGradient(p.bx, p.by, p.bx, p.by + len);
        g.addColorStop(0, viz.cliffMid); g.addColorStop(1, viz.cliffBot);
        c.fillStyle = g; c.fill();
      }
    }
  }

// Baked once per arena size; drawSlabSide scales with the shrinking platform.
Game.prototype.bakeSlabSideTex = function () {
    const r = this.maxRadius;
    const depth = r * CFG.platformDepth, viz = CFG.platformViz;
    const pad = depth * 2.1;
    const half = r + pad;
    const size = Math.ceil(half * 2);
    const cv = document.createElement("canvas");
    cv.width = cv.height = size;
    const c = cv.getContext("2d");
    c.translate(half, half);
    this.paintSlabSide(c, r, depth, viz);
    this._slabSideTex = cv;
    this._slabSideHalf = half;
  }

Game.prototype.drawSlabSide = function (r, depth, viz) {
    if (!this._slabSideTex || this._slabSideTexR !== this.maxRadius) {
      this.bakeSlabSideTex();
      this._slabSideTexR = this.maxRadius;
    }
    const s = r / this.maxRadius;
    const half = this._slabSideHalf * s;
    const size = half * 2;
    this.ctx.drawImage(this._slabSideTex, -half, -half, size, size);
  }

// Top-face rim: soft edge falloff + a gentle front lip (no harsh ink line).
Game.prototype.drawSlabRim = function (r, viz) {
    const c = this.ctx;
    // contact shadow — butt caps so a full ring doesn't pinch into a dot at the seam
    c.lineCap = "butt";
    c.lineJoin = "round";
    c.lineWidth = 4;
    c.strokeStyle = "rgba(8,6,16,0.26)";
    c.beginPath(); c.arc(0, 0, r - 0.5, 0, TAU); c.stroke();
    c.lineWidth = 2;
    c.strokeStyle = "rgba(0,0,0,0.32)";
    c.beginPath(); c.arc(0, 0, r - 0.5, 0, TAU); c.stroke();
    // graded front lip — butt segments tile flush (round caps bead into dots)
    c.lineWidth = 2.5; c.strokeStyle = viz.lip;
    const segs = 32, a0 = -0.22, a1 = Math.PI + 0.22;
    for (let i = 0; i < segs; i++) {
      const t0 = a0 + (a1 - a0) * (i / segs);
      const t1 = a0 + (a1 - a0) * ((i + 1) / segs);
      const lf = (1 - Math.cos((t0 + t1) * 0.5)) / 2;
      c.globalAlpha = 0.06 + 0.44 * lf;
      c.beginPath(); c.arc(0, 0, r - 1.5, t0, t1); c.stroke();
    }
    c.globalAlpha = 1;
  }

Game.prototype.drawPlatform = function () {
    const c = this.ctx;
    let r = this.platformRadius;
    if (!(r > 2)) return;
    const depth = r * CFG.platformDepth;
    const theme = this.arenaTheme();
    const viz = theme.viz ? Object.assign({}, CFG.platformViz, theme.viz) : CFG.platformViz;
    if (!this._platformTex || this._platformTexR !== this.maxRadius) this.bakePlatformTex();
    c.save();
    c.translate(this.ax, this.ay);

    // 1) chunky rocky underside (the 3D body) on the lower rim
    this.drawSlabSide(r, depth, viz);
    if (theme.sideTint) {
      c.save();
      c.globalAlpha = theme.sideTint.alpha;
      c.fillStyle = theme.sideTint.color;
      c.beginPath(); c.arc(0, 0, r * 1.02, 0, TAU); c.fill();
      c.restore();
    }

    // 2) top face: clip to the (shrinking) disc, stamp the world-anchored stone texture,
    //    then darken the rim (ambient occlusion) so the surface reads as curving over the edge.
    c.save();
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.clip();
    const R = this.maxRadius;
    c.drawImage(this._platformTex, -R, -R, R * 2, R * 2);
    const ao = c.createRadialGradient(0, 0, r * 0.72, 0, 0, r);
    ao.addColorStop(0, "rgba(0,0,0,0)");
    ao.addColorStop(1, viz.edgeAO);
    c.fillStyle = ao;
    c.fillRect(-r, -r, r * 2, r * 2);
    this.applyFloorWash(c, r, theme.floorWash);
    c.restore();

    // 3) rim: overhang lip + dark contact line + cool upper-left bevel
    this.drawSlabRim(r, viz);

    c.restore();
  }

/** Client-only ambient particles keyed by arena theme (screen-space parallax). */
Game.prototype.drawArenaAmbient = function () {
  const theme = this.arenaTheme();
  const amb = theme.ambient;
  if (!amb || amb.kind === "none") return;
  if (this.state !== "bossintro" && this.state !== "playing" && this.state !== "countdown" &&
      this.state !== "roundover") return;
  const count = Math.min(48, amb.count ?? 48);
  const key = amb.kind + (amb.rise ? "u" : "d");
  if (!this._arenaAmbient || this._arenaAmbientKey !== key) {
    this._arenaAmbientKey = key;
    this._arenaAmbient = [];
    for (let i = 0; i < count; i++) {
      this._arenaAmbient.push({
        x: Math.random() * this.W,
        y: Math.random() * this.H,
        par: 0.08 + Math.random() * 0.42,
        spd: 18 + Math.random() * 32,
        sz: 1 + Math.random() * 2.2,
        ph: Math.random() * TAU,
      });
    }
  }
  const c = this.ctx;
  const t = this.nowS;
  const ox = this.camX * CFG.starParallax * 0.6;
  const oy = this.camY * CFG.starParallax * 0.6;
  const rise = !!amb.rise;
  const dir = rise ? -1 : 1;
  c.save();
  c.globalCompositeOperation = amb.kind === "snow" ? "lighter" : "source-over";
  for (const fl of this._arenaAmbient) {
    const sway = Math.sin(t * 0.4 + fl.ph) * (amb.kind === "spores" ? 18 : 12);
    const px = ((fl.x + ox * fl.par * 40 + sway) % (this.W + 20)) - 10;
    const py = ((fl.y + dir * t * fl.spd * fl.par + oy * fl.par * 20) % (this.H + 20)) - 10;
    c.globalAlpha = 0.25 + 0.2 * Math.sin(t * 2 + fl.ph);
    c.fillStyle = amb.color;
    c.beginPath();
    c.arc(px, py, fl.sz, 0, TAU);
    c.fill();
  }
  c.restore();
};
